module.exports = __webpack_public_path__ + "static/media/img_congratulation@2x.2d84c9c6.png";